import { useFormAnswersStore } from '@/storage/formAnswers'
import { usePermitFormStore } from '@/storage/permitForm'
import { useSupplementalFormStore } from '@/storage/supplementalForms'

export default function resetForms(): void {
  usePermitFormStore().resetPermitForm()
  useFormAnswersStore().resetFormAnswers()
  useSupplementalFormStore().resetSupplementalForm()
}
